import { buildApiUrl, createHeaders } from "./apiClient";
import { getCurrentUserId } from "./authService";

const parseOrThrow = async (res, fallback) => {
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || fallback);
  return data;
};

/** The member's own link, their invitations, and who joined through them. */
export const getMyReferrals = async () => {
  const userId = getCurrentUserId();
  const res = await fetch(buildApiUrl("/api/referrals/me"), {
    method: "GET",
    headers: createHeaders({ userId }),
  });
  return parseOrThrow(res, "Failed to load your invitations");
};

/**
 * Send invitations. `text` is whatever the member pasted (one address per
 * line, commas, or "Name <addr>"); the server parses it and answers with a
 * status per address: sent | already_member | already_invited | opted_out |
 * invalid | limit | failed.
 */
export const sendReferralInvites = async ({ text, note }) => {
  const userId = getCurrentUserId();
  const res = await fetch(buildApiUrl("/api/referrals/invites"), {
    method: "POST",
    headers: createHeaders({ userId }),
    body: JSON.stringify({ text, note }),
  });
  return parseOrThrow(res, "Failed to send invitations");
};

/** Public: who is behind a /join/<token> link. */
export const resolveReferral = async (token) => {
  const res = await fetch(
    buildApiUrl(`/api/referrals/resolve/${encodeURIComponent(token)}`),
    { method: "GET", headers: createHeaders() },
  );
  return parseOrThrow(res, "Unknown invitation");
};

/** Tokens this feature issues; anything else in ?ref= is a campaign. */
export const isReferralToken = (token) =>
  typeof token === "string" && (token.startsWith("r_") || token.startsWith("i_"));
